import { render, staticRenderFns } from "./ModalInput.vue?vue&type=template&id=f20901ce"
import script from "./ModalInput.vue?vue&type=script&lang=js"
export * from "./ModalInput.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports